import { useEffect, useRef, useState } from 'react';
import { API, catchFunction, redirrect } from '../utils';
export const useActions = (url: string, actionUrl: string) => {
    const viewRef = useRef<HTMLDivElement | null>(null);
    const idRef = useRef<string | null>(null);
    const [viewId, setViewId] = useState<string | null>('');
    idRef.current = viewId;
    const handleView = async (id: string | null) => {
        if (id) {
            try {
                await API.post(`${url}/api/posts/${id}/actions`, {
                    action: 'view',
                });
            } catch (error) {
                catchFunction(error);
            }
        }
    };
    useEffect(() => {
        const observer = new IntersectionObserver((ent) => {
            if (ent[0].isIntersecting && !idRef.current) {
                setTimeout(() => {
                    setViewId(ent[0]?.target?.ariaLabel);
                    handleView(ent[0]?.target?.ariaLabel);
                }, 2000);
            }
        });
        viewRef?.current && observer.observe(viewRef?.current);
    }, []);

    const openInNewTab = async (imageLink: string) => {
        try {
            await API.post(actionUrl, { action: 'click' });
            redirrect(imageLink);
        } catch (error) {
            catchFunction(error);
        }
    };
    return { openInNewTab, viewRef };
};

export default useActions;
